const c = {
  HOVER: "hover",
  CLICK: "click",
  FOCUS: "focus"
};
export {
  c as TRIGGER
};
//# sourceMappingURL=Trigger.js.map
